import * as React from 'react';
import { Route } from 'react-router-dom';
import { WebsiteEventsPage } from './WebsiteEventsPage';
import { WebsiteEventDetailPage } from './WebsiteEventDetailPage';
import { CaptureAttendanceESig } from './CaptureAttendanceESig';
import { CaptureAttendanceQRCode } from './CaptureAttendanceQRCode';
import { CaptureAttendanceSuccess } from './CaptureAttendanceSuccess';
import { CaptureEventFeedback } from './CaptureEventFeedback';
import { CaptureEventFeedbackSuccess } from './CaptureEventFeedbackSuccess';

export const getWebsiteEventsRoutes = (): React.ReactNode => (
  <>
    <Route index element={<WebsiteEventsPage title="Welcome to Careerbook" />} />
    <Route path="events" element={<WebsiteEventsPage />} />
    <Route path="events/:eventSlug" element={<WebsiteEventDetailPage />} />
    <Route path="event-feedback/:eventId" element={<CaptureEventFeedback />} />
    <Route path="event-feedback-success/:ticketBookingId" element={<CaptureEventFeedbackSuccess />} />
    <Route path="attend-qr/:attendanceToken" element={<CaptureAttendanceQRCode />} />
    <Route path="attend/qr/:attendanceToken" element={<CaptureAttendanceQRCode />} />
    <Route path="attend-sign/:ticketBookingId" element={<CaptureAttendanceESig />} />
    <Route path="attend/sign/:ticketBookingId" element={<CaptureAttendanceESig />} />
    <Route path="attend-success/:eventId" element={<CaptureAttendanceSuccess />} />
  </>
);

export const getWebsiteProtectedEventsRoutes = (): React.ReactNode => (
  <Route path="protected/events/:eventSlug" element={<WebsiteEventDetailPage />} />
);
